import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  private _count = 0;
  private _count$ = new BehaviorSubject<number>(this._count);
  private _message$ = new BehaviorSubject<string>('');
  private _zIndex$ = new BehaviorSubject<number>(1020);
  count$ = this._count$.asObservable();
  message$ = this._message$.asObservable();
  zIndex$ = this._zIndex$.asObservable();
  onComplete$ = new Subject<boolean>();

  show(message = '', zIndex = 1020): void {
    this._count++;
    this._count$.next(this._count);
    if (message || (!message && this._count === 1)) {
      // this is a hack to make the spinner work with messages.
      // we have so many empty messages in the app that real messages
      // get removed. This will force us to address this problem.
      // NOTE: Check line 29, it goes with this fix.
      this._message$.next(message);
      this._zIndex$.next(zIndex);
    }
  }

  hide(): void {
    this._count = this._count > 0 ? this._count - 1 : 0;
    if (this._count === 0) {
      this._message$.next('');
      this.onComplete$.next(true);
    }
    this._count$.next(this._count);
  }

  /**
   * Updates the spinner message without modifying the active spinner count.
   * Useful for progress scenarios (e.g., "12 of 100 partners invited...").
   * If no spinner is currently active (count === 0), calling this will implicitly
   * show the spinner with this message to avoid invisible messaging.
   */
  updateMessage(message: string): void {
    if (this._count === 0) {
      // Ensure spinner is visible if updating message when none active.
      this._count = 1;
      this._count$.next(this._count);
    }
    this._message$.next(message);
  }

  reset(): void {
    this._count = 0;
    this._count$.next(this._count);
    this._message$.next('');
    this.onComplete$.next(true);
  }
}
